import moment from 'moment'
import { currencyFormat } from './currencyFormat'
// import { generateBarcodeBase64 } from './makeBarCode.util'

export const htmlReplaceContract: (html: string, data: any) => string = (html, data) => {
  console.warn('🚀 ~ htmlReplaceContract ~ data.s3folder', data.s3folder)
  const isMacstoreMexico = data.s3folder === 'ti_macstore'
  const isSamsungMexico = data.s3folder === 'ti_samsung_mx'
  const isSamsungPeru = data.s3folder === 'ti_samsung_pe'
  const isConectaPeru = data.s3folder === 'ti_conecta_peru'
  const isSamsungRom = data.s3folder === 'ti_samsung_pe_rom'
  const isFalabellaPeru = data.s3folder === 'ti_falabella_pe'
  const isFalabellaChile = data.s3folder === 'ti_falabella'
  const isCoppelMexico = data.s3folder === 'ti_coppel'
  const isReuseChile = data.s3folder === 'ti_reusecl'
  const isXiaomiMexico = data.s3folder === 'ti_xiaomi'
  const isMotorolaChile = data.s3folder === 'ti_motorola'
  const isWomChile = data.s3folder === 'ti_wom'
  const isOppoMexico = data.s3folder === 'ti_oppo'
  const isElektraMexico = data.s3folder === 'ti_elektra_mx'
  const isClaroChile = data.s3folder === 'ti_claro'
  const isPhantomPeru = data.s3folder === 'ti_phantom'
  const isRipleyPeru = data.s3folder === 'ti_ripley_pe'
  const isRipleyChile = data.s3folder === 'ti_ripley_cl'
  const isParisChile = data.s3folder === 'ti_paris'
  const isHuaweiMexico = data.s3folder === 'ti_huawei_mx'
  const isHuaweiPeru = data.s3folder === 'ti_huawei_pe'
  const isHuaweiChile = data.s3folder === 'ti_huawei_cl'
  const isTelcelMexico = data.s3folder === 'ti_telcel_mx'
  const isTelcelCorpMexico = data.s3folder === 'ti_telcel_corp_mx'
  const isHuaweiOnlineChile = data.s3folder === 'ti_huawei_online_cl'
  const isHuaweiOnlineMexico = data.s3folder === 'ti_huawei_online_mx'
  const isHuaweiOnlinePeru = data.s3folder === 'ti_huawei_online_pe'
  const isMercadoLibreChile = data.s3folder === 'ti_mercado_libre_cl'
  const isTecnobuyChile = data.s3folder === 'ti_tecnobuy_cl'
  const isLiverpoolMexico = data.s3folder === 'ti_liverpool_mx'

  if (isCoppelMexico) {
    const fecha = moment().locale('es').format('DD/MM/YYYY')
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion: string = data.address
    const identificacion: string = data.rut
    const ciudad: string = data.city
    const marca: string = data.brand
    const modelo: string = data.model
    const imei: string = data.imei

    html = html.replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{identificacion}}', identificacion)
      .replaceAll('{{ciudad}}', ciudad)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{imei}}', imei)
  }

  if (isReuseChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().locale('es').format('DD/MM/YYYY')
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const identificacion: string = data.rut
    const marca: string = data.brand
    const modelo: string = data.model
    const imei: string = data.imei
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const address: string = data.address + ', ' + data.city
    const sbu: string = data.sbu

    html = html.replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{identificacion}}', identificacion)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{domicilio}}', address)
      .replaceAll('{{sbu}}', sbu)
  }

  if (isFalabellaPeru || isFalabellaChile) {
    console.warn('estoy en el if correcto')
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().locale('es').format('DD/MM/YYYY')
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const identificacion: string = data.rut
    const marca: string = data.brand
    const modelo: string = data.model
    const imei: string = data.imei
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const address: string = data.address + ', ' + data.city
    const sbu: string = data.sbu
    const civilState: string = data.civil_state

    html = html.replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{identificacion}}', identificacion)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{domicilio}}', address)
      .replaceAll('{{sbu}}', sbu)
      .replaceAll('{{estadoCivil}}', civilState)
  }

  if (isXiaomiMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)
    // const barCodeText1 = '(1)OC2712' + String(moment().locale('es').format('YYYYMMDD') + data.discount_amount + '996')
    // const barCodeText2 = '(2)987654321'
    // const barCodeText3 = '(3)' + String(data.imei)
    // const barCodeText4 = '(4)123456789'

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{fullname}}', fullname)
      // .replaceAll('{{barCode1}}', String(generateBarcodeBase64(barCodeText1)))
      // .replaceAll('{{barCode2}}', String(generateBarcodeBase64(barCodeText2)))
      // .replaceAll('{{barCode3}}', String(generateBarcodeBase64(barCodeText3)))
      // .replaceAll('{{barCode4}}', String(generateBarcodeBase64(barCodeText4)))
  }

  if (isMacstoreMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)
    // const barCodeText1 = '(1)OC2712' + String(moment().locale('es').format('YYYYMMDD') + data.discount_amount + '996')
    // const barCodeText2 = '(2)987654321'
    // const barCodeText3 = '(3)' + String(data.imei)
    // const barCodeText4 = '(4)123456789'

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{fullname}}', fullname)
      // .replaceAll('{{barCode1}}', String(generateBarcodeBase64(barCodeText1)))
      // .replaceAll('{{barCode2}}', String(generateBarcodeBase64(barCodeText2)))
      // .replaceAll('{{barCode3}}', String(generateBarcodeBase64(barCodeText3)))
      // .replaceAll('{{barCode4}}', String(generateBarcodeBase64(barCodeText4)))
  }

  if (isSamsungPeru) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const movil = String(data.movil)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{movil}}', movil)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
  }

  if (isSamsungRom) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const idTradein = String(data.id)
    const day = moment().locale('es').format('DD')
    const month = moment().locale('es').format('MM')
    const maxDay = moment().add(30, 'days').locale('es').format('DD')
    const maxMonth = moment().add(30, 'days').locale('es').format('MM')
    const imei = String(data.imei)
    const device = String(data.brand) + ' ' + String(data.model) + ' ' + String(data.capacity)

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
      .replaceAll('{{bank}}', data.bank)
      .replaceAll('{{bank_account}}', data.bank_account)
      .replaceAll('{{interbank_account}}', data.interbank_account)
      .replaceAll('{{idTradein}}', idTradein)
      .replaceAll('{{day}}', day)
      .replaceAll('{{month}}', month)
      .replaceAll('{{max_day}}', maxDay)
      .replaceAll('{{max_month}}', maxMonth)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{device}}', device)
  }

  if (isMotorolaChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{direccion}}', data.rut)
      .replaceAll('{{discount}}', discount)
  }

  if (isWomChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
  }

  if (isConectaPeru) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const direccion = String(data.address) + ', ' + String(data.city)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{domicilio}}', direccion)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{discount}}', discount)
  }

  if (isSamsungMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const rut = String(data.rut)
    const montoRetoma = Number(data.discount_amount)
    const montoReuse = Number(data.discount_amount) - Number(data.boost) <= 0 ? 0 : Number(data.discount_amount) - Number(data.boost)
    const montoSamsung = Number(data.discount_amount) - Number(data.boost) <= 0 ? Number(data.discount_amount) : Number(data.boost)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{DNI}}', rut)
      .replaceAll('{{montoRetoma}}', currencyFormat(montoRetoma, import.meta.env.VITE_COUNTRY))
      .replaceAll('{{montoReuse}}', currencyFormat(montoReuse, import.meta.env.VITE_COUNTRY) === '0' ? '$ 0' : currencyFormat(montoReuse, import.meta.env.VITE_COUNTRY))
      .replaceAll('{{montoSamsung}} ', currencyFormat(montoSamsung, import.meta.env.VITE_COUNTRY) === '0' ? '$ 0' : currencyFormat(montoSamsung, import.meta.env.VITE_COUNTRY))
  }

  if (isOppoMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
  }

  if (isElektraMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
  }

  if (isClaroChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
  }

  if (isPhantomPeru) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const direccion = String(data.address) + ', ' + String(data.city)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{domicilio}}', direccion)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{discount}}', discount)
  }

  if (isRipleyPeru || isRipleyChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const direccion = String(data.address) + ', ' + String(data.city)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{domicilio}}', direccion)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{discount}}', discount)
  }

  if (isParisChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const direccion = String(data.address) + ', ' + String(data.city)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{domicilio}}', direccion)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
  }

  if (isHuaweiMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{fullname}}', fullname)
  }

  if (isHuaweiPeru) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const idTradein = String(data.id)
    const day = moment().locale('es').format('DD')
    const month = moment().locale('es').format('MM')
    const maxDay = moment().add(30, 'days').locale('es').format('DD')
    const maxMonth = moment().add(30, 'days').locale('es').format('MM')
    const imei = String(data.imei)
    const device = String(data.brand) + ' ' + String(data.model) + ' ' + String(data.capacity)

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
      .replaceAll('{{bank}}', data.bank)
      .replaceAll('{{bank_account}}', data.bank_account)
      .replaceAll('{{interbank_account}}', data.interbank_account)
      .replaceAll('{{idTradein}}', idTradein)
      .replaceAll('{{day}}', day)
      .replaceAll('{{month}}', month)
      .replaceAll('{{max_day}}', maxDay)
      .replaceAll('{{max_month}}', maxMonth)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{device}}', device)
  }

  if (isHuaweiChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const idTradein = String(data.id)
    const day = moment().locale('es').format('DD')
    const month = moment().locale('es').format('MM')
    const year = moment().locale('es').format('YYYY')
    const maxDay = moment().add(30, 'days').locale('es').format('DD')
    const maxMonth = moment().add(30, 'days').locale('es').format('MM')
    const imei = String(data.imei)
    const device = String(data.brand) + ' ' + String(data.model) + ' ' + String(data.capacity)

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
      .replaceAll('{{bank}}', data.bank)
      .replaceAll('{{bank_account}}', data.bank_account)
      .replaceAll('{{idTradein}}', idTradein)
      .replaceAll('{{day}}', day)
      .replaceAll('{{month}}', month)
      .replaceAll('{{year}}', year)
      .replaceAll('{{max_day}}', maxDay)
      .replaceAll('{{max_month}}', maxMonth)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{device}}', device)
  }

  if (isTelcelMexico || isTelcelCorpMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const rut = String(data.rut)
    const montoRetoma = Number(data.discount_amount)
    const montoReuse = Number(data.discount_amount) - Number(data.boost) <= 0 ? 0 : Number(data.discount_amount) - Number(data.boost)
    const montoSamsung = Number(data.discount_amount) - Number(data.boost) <= 0 ? Number(data.discount_amount) : Number(data.boost)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{DNI}}', rut)
      .replaceAll('{{montoRetoma}}', currencyFormat(montoRetoma, import.meta.env.VITE_COUNTRY))
      .replaceAll('{{montoReuse}}', currencyFormat(montoReuse, import.meta.env.VITE_COUNTRY) === '0' ? '$ 0' : currencyFormat(montoReuse, import.meta.env.VITE_COUNTRY))
      .replaceAll('{{montoSamsung}} ', currencyFormat(montoSamsung, import.meta.env.VITE_COUNTRY) === '0' ? '$ 0' : currencyFormat(montoSamsung, import.meta.env.VITE_COUNTRY))
  }

  if (isHuaweiOnlineChile || isHuaweiOnlineMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const idTradein = String(data.id)
    const day = moment().locale('es').format('DD')
    const month = moment().locale('es').format('MM')
    const year = moment().locale('es').format('YYYY')
    const maxDay = moment().add(30, 'days').locale('es').format('DD')
    const maxMonth = moment().add(30, 'days').locale('es').format('MM')
    const imei = String(data.imei)
    const device = String(data.brand) + ' ' + String(data.model) + ' ' + String(data.capacity)

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
      .replaceAll('{{bank}}', data.bank)
      .replaceAll('{{bank_account}}', data.bank_account)
      .replaceAll('{{idTradein}}', idTradein)
      .replaceAll('{{day}}', day)
      .replaceAll('{{month}}', month)
      .replaceAll('{{year}}', year)
      .replaceAll('{{max_day}}', maxDay)
      .replaceAll('{{max_month}}', maxMonth)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{device}}', device)
  }

  // Huawei Online Perú usa el mismo contrato que Samsung ROM (incluye {{interbank_account}} y no usa {{year}}).
  if (isHuaweiOnlinePeru) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const idTradein = String(data.id)
    const day = moment().locale('es').format('DD')
    const month = moment().locale('es').format('MM')
    const maxDay = moment().add(30, 'days').locale('es').format('DD')
    const maxMonth = moment().add(30, 'days').locale('es').format('MM')
    const imei = String(data.imei)
    const device = String(data.brand) + ' ' + String(data.model) + ' ' + String(data.capacity)

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
      .replaceAll('{{bank}}', data.bank)
      .replaceAll('{{bank_account}}', data.bank_account)
      .replaceAll('{{interbank_account}}', data.interbank_account)
      .replaceAll('{{idTradein}}', idTradein)
      .replaceAll('{{day}}', day)
      .replaceAll('{{month}}', month)
      .replaceAll('{{max_day}}', maxDay)
      .replaceAll('{{max_month}}', maxMonth)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{device}}', device)
  }

  if (isMercadoLibreChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const direccion = String(data.address) + ', ' + String(data.city)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{domicilio}}', direccion)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{discount}}', discount)
  }

  if (isTecnobuyChile) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const direccion = String(data.address) + ', ' + String(data.city)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{domicilio}}', direccion)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{discount}}', discount)
  }

  if (isLiverpoolMexico) {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const rut = String(data.rut)
    const montoRetoma = Number(data.discount_amount)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{DNI}}', rut)
      .replaceAll('{{montoRetoma}}', currencyFormat(montoRetoma, import.meta.env.VITE_COUNTRY))
  }
  return html
}
